import { Box, Text, Button } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { useContext } from 'react';
import { MeContext } from '../../../context/MeContext';
import { useIsReadOnly } from '../../../hooks/useIsReadOnly';
import LockedActionButton from '../../common/LockedActionButton';

const NoDataBox = ({
  buttonText,
  buttonLink,
  opacity = 1,
  buttonType = 'gradient',
  title = 'No data yet',
  description = 'Try selecting a different date range or check back later',
  fullWidth,
  buttonDisabled = false,
}) => {
  const { organisationStatus } = useContext(MeContext).state;
  const isReadOnly = useIsReadOnly();
  const isButtonDisabled =
    organisationStatus !== 'trial' && organisationStatus !== 'live';

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems={fullWidth ? 'flex-start' : 'center'}
      justifyContent="flex-start"
      textAlign="left"
      opacity={opacity}
      position="relative"
      minH="200px"
    >
      <Text fontSize="16px" fontWeight="bold" mt={fullWidth ? 4 : 10}>
        {title}
      </Text>
      <Text fontSize="16px" mt={4}>
        {description}
      </Text>
      {buttonText &&
        (isReadOnly ? (
          <LockedActionButton
            position="absolute"
            bottom={fullWidth ? 1 : 3}
            mt={12}
            size="md"
            variant={buttonType}
            width={fullWidth ? 'full' : '180px'}
          >
            {buttonText}
          </LockedActionButton>
        ) : (
          <Button
            position="absolute"
            bottom={fullWidth ? 1 : 3}
            as={RouterLink}
            to={isButtonDisabled ? undefined : buttonLink}
            mt={12}
            size="md"
            variant={buttonType}
            width={fullWidth ? 'full' : '180px'}
            disabled={isButtonDisabled}
            _disabled={{
              opacity: 0.5,
              cursor: 'not-allowed',
            }}
          >
            {buttonText}
          </Button>
        ))}
    </Box>
  );
};

export default NoDataBox;
